export const contactsData = {
  email: "officialsiddharthbisht@gmail.com",
  phone: "+91 8077305268",
  address: "Nainital, Uttarakhand, India",

  sheetAPI:
    // "https://docs.google.com/spreadsheets/d/e/2PACX-1vRP1_DZcoT6Xvp4QkMDR4Fa1dZ99MerUjhjilqDHHjNJQgflR3F65poj-U-wS1R9AiM_zTzjpohGd6h/pubhtml",
    // "https://sheets.googleapis.com/v4/spreadsheets/2PACX-1vRP1_DZcoT6Xvp4QkMDR4Fa1dZ99MerUjhjilqDHHjNJQgflR3F65poj-U-wS1R9AiM_zTzjpohGd6h/values/Sheet1!A1:C1?valueInputOption=USER_ENTERED?key=AIzaSyAfXC5XP1pf_zwASUA6ynLPnG0ZCTdPgcc",
    "https://sheetdb.io/api/v1/pbas8o1vnosnp",
};

// "Request is missing required authentication credential. Expected OAuth 2 access token, login cookie or other valid authentication credential. See https://developers.google.com/identity/sign-in/web/devconsole-project."


// api key = AIzaSyDrBVNualoltTWOI5Mkxp4sAP3c85rnNTE

// client Id = 686410709267-gr273ob93mn6v7qavfhv7oculrc4hscq.apps.googleusercontent.com
// client secret = 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


